import React, { useState, useEffect } from "react";
import "./ChatbotPage.css";
import ChatInputBox from "../../components/ChatBotComponents/ChatInputBox";
import Chat from "../../components/Chat";
import TransparentHeader from "../../components/TransparentHeader";
import { useConfig } from "../../context/ConfigProvider";

const ChatbotPage = ({
  setOpen,
  showCloseIcon,
  text,
  image,
  cameraConfig,
  showHeader = true,
}) => {
  const [currentPrompt, setCurrentPrompt] = useState(""); // State for text input
  const [attachedImage, setAttachedImage] = useState(null); // State for image
  const [timestamp, setTimestamp] = useState(null);
  const [customerKey, setCustomerKey] = useState("");
  const [ocid, setOcid] = useState("");
  const { config, fetchConfig, loading, error } = useConfig();
  const [modelConfig, setModelConfig] = useState({
    customerKey: "",
    ocid: "",
    query: "",
    model: "",
    threshold: "",
    context_prompt: "",
    record_size: 100,
    defaultPrompt: "",
  });

  // Extracting parameters from URL
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const customerKeyxOcid = params.get("chatbot");
      if (customerKeyxOcid) {
        const [ck, oid] = customerKeyxOcid.split("x");
        setCustomerKey(ck);
        setOcid(oid);
      }
    } catch (err) {
      console.error(
        "Error while extracting customerKey and ocid from URL: ",
        err
      );
    }
  }, []);

  // Set model config based on the camera config and fetched config
  useEffect(() => {
    if (cameraConfig) {
      setModelConfig(cameraConfig);
      cameraConfig = null;
    }
    if (config) {
      setModelConfig((prevState) => ({
        ...prevState,
        context_prompt: config?.userData?.contextprompt || "",
        customerKey,
        ocid,
        model: config?.userData?.gptversion || "",
        record_size: 100,
        threshold: config?.userData?.threshold || 0.7,
        defaultPrompt: config?.userData?.defaultpromt || "",
      }));
    }
  }, [config, cameraConfig, customerKey, ocid]);

  // Set the prompt text and image when props change
  useEffect(() => {
    if (text && image && text !== "") {
      setAttachedImage(image);
      setCurrentPrompt(text.trim());
    }
  }, [image, text]);

  // Handle sending a message
  const handleSend = ({ text = "", image = null }) => {
    if (text.trim() || image) {
      setCurrentPrompt(text.trim());
      setAttachedImage(image);
      setTimestamp(new Date().toLocaleTimeString());
    }
  };

  return (
    <div className="chatbot-page">
      {/* Top Banner */}
      {showHeader && (
        <TransparentHeader
          showLeftIcon={showCloseIcon}
          leftIconCallbackMethod={setOpen}
        />
      )}
      {/* Content Area */}
      <div className="chatbot-content">
        <Chat
          text={currentPrompt} // Text input from the state
          image={attachedImage} // Attached image state
          timestamp={timestamp || new Date().toLocaleTimeString()}
          setOpen={setOpen}
          modelConfig={modelConfig}
        />
      </div>
      {/* Input Box at Bottom */}
      <div className="chatbot-input-box">
        <ChatInputBox onSend={handleSend} />
      </div>
    </div>
  );
};

export default ChatbotPage;
